import React, { useState, useEffect } from "react";
import "./Domain.css"; // Import the CSS for additional custom styling
import LoadingSpinner from "../../../LoadingSpinner/LoadingSpinner"; // Import the loading spinner component
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css"; // Core Swiper styles
import "swiper/css/navigation"; // Navigation module styles
import { Navigation } from "swiper/modules";

const Domain = () => {
  const [domains, setDomains] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [showOriginalDomains, setShowOriginalDomains] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetch("https://api.spadserver.com/api/domain")
      .then((response) => response.json())
      .then((data) => setDomains(data))
      .finally(() => setLoading(false));
  }, []);

  const getImageForDomain = (domainTitle) => {
    switch (domainTitle.toLowerCase()) {
      case "com":
        return "images/123.png";
      case "org":
        return "images/org(2).png";
      case "ir":
        return "images/ir(2).png";
      case "net":
        return "images/net(2).png";
      case "co":
        return "images/co(2).png";
      case "info":
        return "images/info(2).png";
      case "shop":
        return "images/shop(2).png";
      case "online":
        return "images/online(2).png";
      case "tech":
        return "images/tech(2).png";
      case "store":
        return "images/store(2).png";
      case "me":
        return "images/me(2).png";
      case "art":
        return "images/art(2).png";
      case "blog":
        return "images/blog(2).png";
      case "security":
        return "images/security.png";
      case "software":
        return "images/software.png";
      case "social":
        return "images/social.png";
      case "trade":
        return "images/trade.png"
      case "xyz":
        return "images/xyz.png";
      case "be":
        return "images/be.png";
      case "beauty":
        return "images/beauty.png";
      case "cam":
        return "images/cam.png";
      case "ceo":
        return "images/ceo.png";
      case "click":
        return "images/click.png";
      case "company":
        return "images/company.png";
      case "cloud":
        return "images/cloud.png";
      case "download":
        return "images/download.png";
      case "direct":
        return "images/direct.png";
      case "email":
        return "images/email.png";
      case "fitness":
        return "images/fitness.png";
      case "fun":
        return "images/fun.png";
      case "games":
        return "images/games.png";
      case "in":
        return "images/in.png";
      case "live":
        return "images/live.png";
      case "network":
        return "images/network.png";
      case "news":
        return "images/news.png";
      case "sbs":
        return "images/sbs.png";
      case "dev":
        return "images/dev.png";
      case "wtf":
        return "images/wtf.png";
      case "website":
        return "images/website.png";
      case "vip":
        return "images/vip.png";
      case "team":
        return "images/team.png";
      case "site":
        return "images/site.png";
      default:
        return "images/default-domain.png"; // Fallback for unspecified domains
    }
  };

  const handleSearch = (event) => {
    event.preventDefault();
    setLoading(true);
    setShowOriginalDomains(false);
    fetch(`https://api.spadserver.com/api/domain-search?domain=${searchTerm}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data && data.other) {
          setSearchResults(data.other);
        }
      })
      .finally(() => setLoading(false));
  };

  const stripHtmlTags = (str) => {
    if (typeof str !== 'string') {
      console.warn("stripHtmlTags received a non-string value:", str);
      return '';
    }
    return str
      .replace(/<\/?[^>]+(>|$)/g, "")
      .replace(/&zwnj;/g, "")
      .replace(/&nbsp;/g, " ");
  }; 

  const formattedPrice = (price) => {
    return new Intl.NumberFormat().format(price);
  };

  // Check screen width to determine if Swiper should be used
  const isMobile = window.innerWidth < 640;

  return (
    <div className="mx-auto text-white mt-0 relative">
      {loading && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-70 z-50">
          <LoadingSpinner />
        </div>
      )}

      <div className="grid mx-4 lg:flex lg:justify-between lg:items-center md:grid-cols-1">
        <div className="">
          <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-6 lg:mb-10">
            ثبت دامنه
          </h1>
          <p>
            {" "}
            ثبت دامنه و خرید انواع پسوند های دامنه از اسپاد سرور همین امروز
            دامنه خود را با قیمت مناسب ثبت کنید.
          </p>
        </div>

        <div className="domainPicture">
          <img
            src="images/mainDomain.png"
            alt="ثبت دامنه"
            className="w-full max-w-xs md:max-w-md lg:max-w-lg"
          />
        </div>
      </div>

      {/* Search Bar */}
      {/* Domain Search Input */}
      {/* Domain Search Input */}
      <div
        className="p-4 sm:p-6 lg:p-10 mb-6 sm:mb-8 grid grid-cols-1 lg:grid-cols-2 gap-8 rounded-xl mt-10" // Increased gap from 4 to 8
        style={{ backgroundColor: "#2b324d" }}
      >
        <div className="flex flex-col">
          <div className="text-white text-lg sm:text-xl lg:text-2xl mb-4 text-right lg:text-right">
            بهترین نام دامنه را برای وب سایت خود پیدا کنید.
          </div>
          <div className="text-[12px] sm:text-[14px] text-white text-center lg:text-right mt-10 lg:hidden">
            آیا دامنه دارید؟{" "}
            <a
              href="https://crm.spadserver.com/cart.php?a=add&domain=transfer"
              className="text-white border-b border-white"
            >
              می‌توانید دامنه را انتقال دهید.
            </a>
            <div className=" border-gray-300 mt-2"></div>
          </div>
        </div>

        <form
          onSubmit={handleSearch}
          className="flex flex-col lg:flex-row gap-2 sm:gap-0 bg-white lg:rounded-[2rem] lg:p-1 rounded-[30px] p-5"
        >
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="نام دامنه‌ی خود را وارد کنید."
            className="p-2 pr-20 text-sm  text-black bg-white focus:outline-none focus:ring-0 rounded-md sm:rounded-none lg:rounded-r-[2rem] flex-1 w-full placeholder:text-gray-500 placeholder:opacity-70"
          />

          <button
            type="submit"
            className="search-button p-4 lg:ml-2 lg:my-2 text-black text-sm sm:text-base rounded-[20px] lg:rounded-r-[2rem] lg:rounded-l-[2rem] hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 w-full lg:w-[160px]"
          >
            جستجو
          </button>
        </form>

        <div className="">
          <div className="text-[12px] sm:text-[14px] text-white text-center lg:text-right mt-10 lg:block hidden">
            آیا دامنه دارید؟{" "}
            <a
              href="https://crm.spadserver.com/cart.php?a=add&domain=transfer"
              className="text-white border-b border-white"
            >
              می‌توانید دامنه را انتقال دهید.
            </a>
            <div className=" border-gray-300 mt-2"></div>
          </div>
        </div>
        <div className="grid grid-cols-6">
          <div className="flex flex-col items-center">
            <div className="text-white lg:text-lg text-[10px] ">online.</div>
            <div className="text-white lg:text-lg text-[10px] lg:mt-2 mt-0">
              3.3 €
            </div>
          </div>
          <div className="flex flex-col items-center">
            <div className="text-white lg:text-lg text-[10px]">net.</div>
            <div className="text-white lg:text-lg text-[10px] lg:mt-2 mt-0">
              17.5 €
            </div>
          </div>
          <div className="flex flex-col items-center">
            <div className="text-white lg:text-lg text-[10px]">IR.</div>
            <div className="text-white lg:text-lg text-[10px] lg:mt-2 mt-0">
              40000 IRT
            </div>
          </div>
          <div className="flex flex-col items-center">
            <div className="text-white lg:text-lg text-[10px]">info.</div>
            <div className="text-white lg:text-lg text-[10px] lg:mt-2 mt-0">
              4.3 €
            </div>
          </div>
          <div className="flex flex-col items-center">
            <div className="text-white lg:text-lg text-[10px]">org.</div>
            <div className="text-white lg:text-lg text-[10px] lg:mt-2 mt-0">
              9.2 €
            </div>
          </div>
          <div className="flex flex-col items-center">
            <div className="text-white lg:text-lg text-[10px]">com.</div>
            <div className="text-white lg:text-lg text-[10px] lg:mt-2 mt-0">
              14.2 €
            </div>
          </div>
        </div>
      </div>

      {/* Domain Search Results */}
      {!showOriginalDomains && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4 mb-8 mx-4">
          {searchResults.map((domain, index) => (
            <div
              key={index}
              className="relative p-4 border rounded-lg bg-gray-800 border-gray-700 hover:border-gray-500 hover:bg-gray-700 transition duration-300 ease-in-out"
            >
              <div className="domain-content text-center">
                <h2 className="domain-text-search text-lg md:text-xl font-semibold mb-2 text-white hover:text-green-400">
                  دامنه {domain.tls}
                </h2>
                <div className="annually-search text-white mb-2">(سالانه)</div>
                <div className="bottom-content flex justify-between items-center">
                  <p
                    className={`mt-2 font-bold text-sm ${
                      domain.isAvailable ? "text-green-400" : "text-red-400"
                    }`}
                  >
                    {domain.isAvailable ? "در دسترس" : "غیر قابل دسترس"}
                  </p>
                  {domain.isAvailable && (
                    <a
                      href={`https://crm.spadserver.com/cart.php?a=add&domain=${searchTerm}.${domain.tls}`}
                      className="purchase-button bg-black mt-4 block text-center py-2 px-4 rounded hover:bg-gray-800"
                    >
                      خرید دامنه
                    </a>
                  )}
                </div>
              </div>
              <div className="domain-description mt-2 text-gray-300 text-sm">
                <p>
                  Availability:{" "}
                  {domain.isAvailable ? "در دسترس" : "غیر قابل دسترس"}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Existing Domain Data */}
      {showOriginalDomains && (
        <>
          {isMobile ? (
            <div className="mb-8">
              <Swiper
                modules={[Navigation]}
                navigation={true}
                loop={false}
                spaceBetween={0}
                slidesPerView={1}
                centeredSlides={true}
                breakpoints={{
                  640: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                  },
                  768: {
                    slidesPerView: 2.5,
                    spaceBetween: 10,
                  },
                  1024: {
                    slidesPerView: 4,
                    spaceBetween: 10,
                    centeredSlides: false,
                  },
                }}
              >
                {domains.map((domain, index) => (
                  <SwiperSlide key={index} className="relative card-container">
                    <div className="domain-content text-center">
                      <div className="image-title-container">
                        <img
                          className="w-12 md:w-20 mx-auto"
                          src={getImageForDomain(domain.title)} // Use the helper function here
                          alt={`domain ${domain.title}`}
                        />
                      </div>
                      <h2 className="domain-text text-lg md:text-xl font-semibold mb-2 text-white hover:text-green-400">
                        دامنه {domain.title}
                      </h2>
                      <div className="annually-search text-white mb-2">
                        (سالانه)
                      </div>
                      <div className="bottom-content flex justify-between items-center">
                        <p className="mt-2 font-bold text-xs md:text-[14px]">
                          {formattedPrice(domain.year)} {domain.currency.suffix}
                        </p>
                        <a
                          href={domain.slug}
                          className="purchase-button bg-black mt-4 block text-center py-2 px-4 rounded hover:bg-gray-800"
                        >
                          خرید دامنه
                        </a>
                      </div>
                    </div>
                    <div className="domain-description mt-2 text-gray-300 text-sm">
                      <p>{stripHtmlTags(domain.description)}</p>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4 mx-4">
              {domains.map((domain, index) => (
                <div key={index} className="relative card-container">
                  <div className="domain-content text-center">
                    <div className="image-title-container">
                      <img
                        className="w-12 md:w-20 mx-auto"
                        src={getImageForDomain(domain.title)} // Use the helper function here
                        alt={`domain ${domain.title}`}
                      />
                    </div>
                    <h2 className="domain-text text-lg md:text-xl font-semibold mb-2 text-white hover:text-green-400">
                      دامنه {domain.title}
                    </h2>
                    <div className="annually-search text-white mb-2">
                      (سالانه)
                    </div>
                    <div className="bottom-content flex justify-between items-center">
                      <p className="mt-2 text-domain font-bold text-xs md:text-[14px] sm:text-[13px]">
                        {formattedPrice(domain.year)} {domain.currency.suffix}
                      </p>
                      <a
                        href={domain.slug}
                        className="purchase-button bg-black mt-4 block text-center py-2 px-4 rounded hover:bg-gray-800"
                      >
                        خرید دامنه
                      </a>
                    </div>
                  </div>
                  <div className="domain-description mt-2 text-gray-300 text-sm">
                    <p>{stripHtmlTags(domain.description)}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Domain;
